export function hasClassName(classes, key) {
  return key in classes;
}

export function getClassName(classes, key) {
  return hasClassName(classes, key)
    ? classes[key]
    : null;
}

export const prepareGradientStrokes = (canvas) => {
  let ctx = canvas.getContext("2d");

  let gradientStrokePrimary = ctx.createLinearGradient(0, 230, 0, 50);
  gradientStrokePrimary.addColorStop(1, "rgba(255, 193, 7,0.2)");
  gradientStrokePrimary.addColorStop(0.4, "rgba(255, 193, 7,0.0)");
  gradientStrokePrimary.addColorStop(0, "rgba(255, 193, 7,0)"); 

  let gradientStrokeSecondary = ctx.createLinearGradient(0, 230, 0, 50);
  gradientStrokeSecondary.addColorStop(1, "rgba(78, 78, 78, 0.3)");
  gradientStrokeSecondary.addColorStop(0.4, "rgba(78, 78, 78, 0.0)");
  gradientStrokeSecondary.addColorStop(0, "rgba(78, 78, 78, 0.0)"); 

  return {primary: gradientStrokePrimary, secondary: gradientStrokeSecondary}
}